import styled from 'styled-components';

interface ArrowButtonProps {
  direction: 'left' | 'right';
}

const ArrowButton = styled.button<ArrowButtonProps>`
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(props) => (props.direction === 'left' ? 'left: 20px;' : 'right: 20px;')}

  &::before {
    content: '${(props) =>
      props.direction === 'left'
        ? '\\276E'
        : '\\276F'}'; /* Unicode for arrows */
    font-size: 24px;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

export default ArrowButton;
